var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.templates && _vm.templates.length)?_c('v-autocomplete',{attrs:{"solo":"","dense":"","items":_vm.templates,"item-text":"name","return-object":"","label":_vm.getLabel()},on:{"change":_vm.change},model:{value:(_vm.selectedTemplate),callback:function ($$v) {_vm.selectedTemplate=$$v},expression:"selectedTemplate"}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }